
import securityService from "@/service/security.service";
import { AppType } from "@/types/app.type";
import { defineComponent } from "vue";
import StationsView from "../admin/Stations.view.vue";

export default defineComponent({
  components: { StationsView },
  name: "Home",
  data() {
    return {
      canAccessAdmin: false,
      canAccessSupport: false,
      canAccessStations: false,
      canAccessSace: false,
      canAccessProcessTracking: false,
      canAccessIssueMonitoring: false,
      hasMultiplesApps: false,
    };
  },
  created() {
    this.canAccessAdmin = securityService.canAccessToApp(AppType.ADMIN);
    this.canAccessSupport = securityService.canAccessToApp(AppType.SUPPORT);
    this.canAccessStations = securityService.canAccessToApp(AppType.STATIONS);
    this.canAccessSace = securityService.canAccessToApp(AppType.SACE);
    this.canAccessProcessTracking = securityService.canAccessToApp(AppType.PROCESS_TRACKING);
    this.canAccessIssueMonitoring = securityService.canAccessToApp(AppType.ISSUE_MONITORING);
    if (
      Number(this.canAccessAdmin) +
        Number(this.canAccessProcessTracking) +
        Number(this.canAccessSupport) +
        Number(this.canAccessStations) +
        Number(this.canAccessIssueMonitoring) >
      1
    ) {
      this.hasMultiplesApps = true;
    }
    if (!this.hasMultiplesApps && this.canAccessSupport) {
      this.$router.push("/support/samplingPoints");
    }
  },
  methods: {
    go: function (page: string) {
      this.$router.push(page);
    },
  },
});
